export enum TypeBaliseEnum {
    NESTED = 'NESTED',
    ITEM = 'ITEM'
}
